import { render, staticRenderFns } from "./DefaultModal.vue?vue&type=template&id=08fcbd30&scoped=true&"
import script from "./DefaultModal.vue?vue&type=script&lang=js&"
export * from "./DefaultModal.vue?vue&type=script&lang=js&"
import style0 from "./DefaultModal.vue?vue&type=style&index=0&id=08fcbd30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fcbd30",
  null
  
)

export default component.exports